import React from "react";

/**
 * FlowGantt logo: the exact same mark as the favicon (public/icon.svg, vector twin of favicon.ico).
 * The SVG carries its own rounded tile, so callers only set the size (e.g. "h-7 w-7").
 */
export default function BrandLogo({ className = "h-7 w-7", ...rest }) {
  return (
    <img
      src="/icon.svg"
      alt=""
      aria-hidden="true"
      width="64"
      height="64"
      draggable="false"
      className={`block shrink-0 select-none ${className}`}
      {...rest}
    />
  );
}
